// T-141 B (v1.8.43, Review Befund 1): Der Link "Als Angebot anlegen" aus der Terminanfrage-Mail führt auf /admin/booking-new?anfrage=1&...
// Ist die Verwaltung nicht angemeldet, leitet ProtectedRoute auf /login um, und die Vorbelegung ging verloren (Admins landen fest
// im Dashboard; returnUrl gilt seit T-136 bewusst nur für Kunden). Deshalb wird genau dieser eine Pfad im sessionStorage gemerkt
// und nach der Anmeldung als Admin einmalig wieder geöffnet. Kein anderer Admin-Pfad, kein offener Redirect. Getestet in
// adminRuecksprung.test.ts.

const SCHLUESSEL = 'ff_admin_anfrage_ruecksprung';
const PFAD = '/admin/booking-new';
const MAX = 2000;

/** true für den Link aus der Terminanfrage-Mail (Pfad /admin/booking-new mit anfrage=1). */
export function istAnfrageLink(pfad: string, suche: string): boolean {
  if (pfad !== PFAD) return false;
  try {
    return new URLSearchParams(suche).get('anfrage') === '1';
  } catch {
    return false;
  }
}

/** Prüft einen gemerkten Wert: nur /admin/booking-new?..., keine Steuerzeichen, begrenzte Länge. */
export function sichererAdminRuecksprung(wert: string | null | undefined): string | null {
  if (!wert || wert.length > MAX) return null;
  if (!wert.startsWith(PFAD + '?')) return null;
  if (wert.includes('\\') || wert.includes('//') || Array.from(wert).some(z => z.charCodeAt(0) < 32)) return null;
  return istAnfrageLink(PFAD, wert.substring(PFAD.length)) ? wert : null;
}

/** Vor der Umleitung auf /login: Anfrage-Link merken (andere Pfade werden ignoriert). */
export function merkeAdminRuecksprung(pfad: string, suche: string): void {
  if (!istAnfrageLink(pfad, suche)) return;
  const wert = pfad + suche;
  if (!sichererAdminRuecksprung(wert)) return;
  try {
    sessionStorage.setItem(SCHLUESSEL, wert);
  } catch {
    // ohne Speicher: Anmeldung führt wie bisher ins Dashboard
  }
}

/** Nach der Anmeldung als Admin: gemerkten Anfrage-Link einmalig holen (und löschen). */
export function holeAdminRuecksprung(): string | null {
  try {
    const wert = sessionStorage.getItem(SCHLUESSEL);
    sessionStorage.removeItem(SCHLUESSEL);
    return sichererAdminRuecksprung(wert);
  } catch {
    return null;
  }
}

/** Nicht-Admin-Anmeldung: gemerkten Link verwerfen. */
export function verwirfAdminRuecksprung(): void {
  try {
    sessionStorage.removeItem(SCHLUESSEL);
  } catch {
    // nichts
  }
}
